import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function urlValidator(control: AbstractControl): ValidationErrors | null {
  const urlPatternValidator = Validators.pattern(
    "(((https?|http?)://)(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9{}])+)([).!';/?:,][[:blank:|:blank:]])?$"
  );

  const validationErrors: ValidationErrors | null = urlPatternValidator(control);

  return validationErrors?.['pattern'] ? { invalidUrl: true } : null;
}
